import styled from 'styled-components';

import { theme } from '../../../../common/ui/theme';

interface OfferCardContainerProps {
    expanded: boolean;
}

export const OfferCardContainer = styled.div<OfferCardContainerProps>`
    background-color: ${theme.colors.background.default};
    display: flex;
    flex-direction: column;
    min-height: 145px;
    position: relative;
    z-index: ${theme.zIndex[200]};
    border-radius: 8px;
    border: 1px solid ${theme.colors.border.muted};
    transition: box-shadow 75ms ease-in-out;

    box-shadow: ${(props) => (props.expanded ? theme.shadows.medium : 'none')};

    &:hover {
        box-shadow: ${theme.shadows.medium};
    }
`;
